module.exports = __webpack_public_path__ + "static/media/CNBC_Economist_Logo_White.6a5b2360.png";